import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { pipe } from 'rxjs';

import { PipelineService } from '@app/core/pipelines/services/pipeline.service';
import { ProductDesignService } from '@app/core/quotes/services/product-design.service';
@Component({
  selector: 'cnc-nd-pipeline-popup',
  templateUrl: './nd-pipeline-popup.component.html',
  styleUrls: ['./nd-pipeline-popup.component.scss'],
})
export class NdPipelinePopupComponent implements OnInit {
  pageTitle :string = 'Set Product Design Pipelines';
  pipelines :any[] = [];
  designPipelines :any[] = [];
  loading :boolean;

  @Input() design :any;
  @Input() designs :any;

  constructor(
    public activeModal :NgbActiveModal,
    public pipelineSvc :PipelineService,
    private designSvc :ProductDesignService,
    private toastr :ToastrService,
  ) {}

  ngOnInit() {
    this.pipelineSvc.pipelines$.subscribe((pipelines) => {
      if (pipelines && pipelines.data) {
        // this.pipelines = pipelines.data.filter((row) => row.pipeline_type == 2);
        this.pipelines = pipelines.data;

        if (this.design) {
          if (this.design.pipelines && this.design.pipelines.length > 0) {
            this.design.pipelines.forEach((p) => {
              const pipeline = this.pipelines.find(
                (row) => row.id == p.pipeline_id,
              );
              if (pipeline) {
                this.designPipelines.push({
                  pipeline_id: p.pipeline_id,
                  stage_id: p.pipeline_stage_id,
                  priority: p.priority,
                  stages: pipeline.stages,
                });
              }
            });
          }
        } else if (this.designs) {
        }
      }
    });
  }

  setStages(idx :number) {
    const p = this.designPipelines[idx];
    const pipeline = this.pipelines.find(
      (row) => row.id == this.designPipelines[idx].pipeline_id,
    );
    if (pipeline) {
      this.designPipelines[idx].stages = pipeline.stages;
      this.designPipelines[idx].stage_id = pipeline.stages[0].id;
    }
  }

  addPipeline(designPipeline ?:any) {
    this.designPipelines.push({
      pipeline_id: 0,
      stage_id: 0,
      stages: [],
    });
  }

  saveRfqPipelines() {
    const pipelines = [];
    this.designPipelines.forEach((rp :any) => {
      if (rp.pipeline_id) {
        pipelines.push({
          pipeline_id: rp.pipeline_id,
          pipeline_stage_id: rp.stage_id,
          priority: rp.priority,
        });
      }
    });

    this.loading = true;
    if (this.design && this.design.id) {
      this.designSvc
        .setDesignPipelines(this.design.id, { pipelines: pipelines })
        .subscribe(
          (resp :any) => {
            this.loading = false;
            this.toastr.success('Pipelines updated.');
            this.activeModal.close(pipelines);
          },
          (err) => {
            this.loading = false;
            this.toastr.error(
              'Error updating pipelines, please try again later or contact support.',
            );
          },
        );
    } else if (this.designs) {
      this.designSvc
        .setDesignPipelines(0, {
          pipelines: pipelines,
          design_ids: this.designs.map((row) => row.id),
        })
        .subscribe(
          (resp :any) => {
            this.loading = false;
            this.toastr.success('Pipelines updated.');
            this.activeModal.close(pipelines);
          },
          (err) => {
            this.loading = false;
            this.toastr.error(
              'Error updating pipelines, please try again later or contact support.',
            );
          },
        );
    }
  }
}
